import React from "react";
import '../css/AboutPage.css';
import Header from "../Common/Header";
import Footer from "../Common/Footer";



const AboutPage = () => {
  return (
    <div className="about-wrapper">

      
      <Header/>
    
      <section className="about-section">
        <div className="about-text">
          <h2>About us</h2>
          <p>
            At Sess, we’re redefining how businesses manage their operations,
            relationships, and growth. At Sess,we don’t just produce software —
            we provide solutions that drive success.
          </p>
        </div>
        <img src="./images/aboutpage.jpg" alt="About Us" />
      </section>

      <section className="goal-section">
        <img src="./images/ourgoal.jpg"alt="Goal" />
        <div>
          <h3>Our Goal</h3>
          <p>
            Our goal is to simplify business management by providing an
            intelligent,all-in-one CRM tailored to modern business needs. We
            aim to streamline  critical workflows, enhance collaboration, and
            empower decision-making — enabling businesses to scale efficiently
            and sustainably.
          </p>
        </div>
      </section>

      <section className="story-section">
        <div>
          <h3>Our Story</h3>
          <p>
            Sess began with a simple idea — to make business management easier,
            smarter, and more accessible. As entrepreneurs ourselves, we
            understood the challenges digital businesses face. In 2020, we
            created Sess, a next-generation SaaS app powered by cloud
            technology. From customer insights to integrations and real-time
            analytics, we built every feature with precision and passion.
          </p>
        </div>
        <img src="./images/oursees.jpg"alt="Goal" />
      </section>

      <section className="resources-section">
        <h3>Our Resources</h3>
        <div className="cards">
          <div className="card">
            <h4>🔧 Support & Help Center</h4>
            <ul>
              <li>Tutorials & support docs</li>
              <li>Chat & email support FAQs</li>
              <li>Quick start guides</li>
              <li>Troubleshooting PDFs</li>
            </ul>
          </div>
          <div className="card">
            <h4>📄 Reports & Templates</h4>
            <ul>
              <li>Downloadable, easy-to-use templates</li>
              <li>Visual tracking templates</li>
              <li>Reports for team performance</li>
              <li>Productivity checklists</li>
            </ul>
          </div>
          <div className="card">
            <h4>🔒 Security & Compliance</h4>
            <ul>
              <li>Data privacy and policies</li>
              <li>Role-based access controls</li>
              <li>Admin dashboard features</li>
              <li>Backup & recovery best practices</li>
            </ul>
          </div>
        </div>
      </section>

     

<Footer/>
    
      
    </div>
    
  );
};

export default AboutPage;
